import React, {useEffect} from "react";

import List from '@mui/material/List';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import Collapse from '@mui/material/Collapse';

import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

import MenuItemComponent from "./MenuItemComponent";

const MenuItem = (props) => {
    const {name, uri, Icon, level, divider, items = []} = props;
    const isExpandable = items && items.length > 0;
    const isDevider = divider
    const [open, setOpen] = React.useState(false);

    function handleClick() {
        setOpen(!open);
    }

    const MenuItemRoot = (
        <MenuItemComponent
            uri={uri}
            onClick={handleClick}
            level={level}
        >
            {!!Icon && (
                <ListItemIcon>
                    <Icon/>
                </ListItemIcon>
            )}
            <ListItemText primary={name} inset={!Icon}/>
            {isExpandable && !open && <ExpandMore/>}
            {isExpandable && open && <ExpandLess/>}
        </MenuItemComponent>
    );

    const MenuItemChildren = isExpandable ? (
        <Collapse in={open} timeout="auto" unmountOnExit>
            <Divider/>
            <List component="div" disablePadding>
                {items.map((item, index) => (
                    item && <MenuItem {...item} key={index}/>
                ))}
            </List>
        </Collapse>
    ) : null;

    return (
        <>
            {!isDevider && MenuItemRoot}
            {!isDevider && MenuItemChildren}
            {isDevider && <Divider/>}
        </>
    );
};

export default MenuItem;
